import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ServiceBase } from './service-base';
import { ResultVO } from './vo/CommonVO';
import { environment } from 'src/environments/environment';


@Injectable({ providedIn: 'root' })
export class MyService extends ServiceBase {

  apiu: string = "";
  apiEndpoint: string = "";
  apiPrefix: string = "";

  constructor(public http: HttpClient) { 
    super(http);    
    this.apiEndpoint = environment.urls.apiEndpoint;
    this.apiPrefix = environment.urls.prefix;
    this.apiu =  this.apiEndpoint+"/"+ this.apiPrefix;
  }
  // apiurl: string = GlobalVar.agapiUrl + "api/ag/query/marketsByType?type=";

  /**
   * 執行Http Get Request
   * @param url 呼叫的網址加?key=value
   */
  DoGet(url): Observable<ResultVO> {
    var u = this.apiEndpoint + "/" + this.apiPrefix + url;
    console.log("MyService.DoGet " + u);
    return super.ComonGet(u);
  }

  /**
   * 執行Http Get Request
   * @param url 呼叫的網址加
   * @param jsonObject
   */
  DoGetParams(url, jsonObject): Observable<ResultVO> {
    var u = this.apiEndpoint + "/" + this.apiPrefix + url;

    let pams = "?";

    pams += this.generateParams(jsonObject);
    
    console.log("MyService.DoGet " + u+pams);
    
    if (pams.length > 1) {
      return super.ComonGet(u + pams);
      //return this.DoGet(u + pams);
    } else {
      return super.ComonGet(u);
    }
  }

  /**
   *
   * @param url 呼叫的網址
   * @param dataJsonFormat   data in json format
   */
  DoPost(url, dataJsonFormat): Observable<ResultVO> {
    var u = this.apiEndpoint + "/" + this.apiPrefix + url;
    console.log("DoPost " + u + "values:" + JSON.stringify(dataJsonFormat));
    return super.CommonPost(u, dataJsonFormat);
  }
    /**
   *
   * @param url 呼叫的網址
   * @param dataJsonFormat   data in json format
   */
    DoPostRaw(url, data): Observable<ResultVO> {
      var u = this.apiEndpoint + "/" + this.apiPrefix + url;
    
      return super.CommonPostRaw(u, data);
    }

  /**
   * 將json物件組成 url後台的參數型式 key1=xxx&key2=xxx&....
   * @param jsonObject
   */
  private generateParams(jsonObject): string {
    let i = 0;
    let pams = "";
    Object.keys(jsonObject).forEach(function (key) {
      if (i == 0) {
        pams += key + "=" + encodeURI(jsonObject[key]);
      } else {
        pams += "&" + key + "=" + encodeURI(jsonObject[key]);
      }
      i++;
    });
    return pams;
  }
  /**轉換json to x-www-form-urlencoded */
  transformRequest(obj) {
    var str = [];
    for (var p in obj) {
      var value: string;
      if (obj[p] == null) {
        value = "";
      } else {
        value = encodeURIComponent(obj[p])
      }
      str.push(encodeURIComponent(p) + "=" + value);
    } return str.join("&");
  }


 
}